module.exports = __webpack_public_path__ + "fonts/nunito-sans-v11-latin-regular.890d934b.woff";